import { render } from "./Sort.vue?vue&type=template&id=da07e642"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__